// import { LockClosedIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import Button from "components/atoms/buttons/Button";
import { CloseIcon } from "components/atoms/Icon";
import Modal from "components/atoms/modal";
// import RadioButtonWithLabel from "components/molecules/forms/RadioButtonWithLablel";

type Props = {
  onClose?: any;
  open: boolean;
  selectedActivation: string | undefined;
  availableActivations: Activation[];
  onClickActivate: any;
  setValue: any;
  handlePurchaseActivation: (activationId: any) => void;
};

function ActivationCard({
  name,
  activationKey,
  description,
  type,
  imgURL,
  checked,
  disabled,
  onClick,
}: {
  name: string;
  activationKey: string;
  description: string | null;
  type: string;
  imgURL?: string;
  checked: boolean;
  disabled: boolean;
  onClick: (actKey: string) => void;
}) {
  return (
    <label
      onClick={() => onClick(activationKey)}
      htmlFor={activationKey}
      className="group relative flex w-96 cursor-pointer rounded-lg border-opacity-40 p-4 font-satoshi shadow-sm hover:bg-white hover:bg-opacity-5 focus:outline-none"
    >
      <input
        checked={checked}
        type="radio"
        name="activation"
        value={activationKey}
        id={activationKey}
        className="sr-only"
        aria-labelledby="project-type-0-label"
        aria-describedby="project-type-0-description-0 project-type-0-description-1"
        disabled={disabled}
      />
      <span className="flex flex-1">
        <span className="flex flex-col">
          <span id="project-type-0-label" className="block text-sm font-black text-white text-opacity-90">
            {name}
          </span>
          <span id="project-type-0-description-1" className="text-base font-medium text-gray-400">
            {type}
          </span>
          <div className="flex gap-2">
            <span
              id="project-type-0-description-0"
              className="flex items-center text-[0.9rem] font-medium leading-snug text-gray-300"
            >
              {description}
            </span>
            {imgURL && (
              <img
                src={imgURL}
                alt="activation logo"
                className={clsx("-mr-5 mt-5 aspect-1 h-9", checked ? "" : "grayscale")}
              />
            )}
          </div>
        </span>
      </span>

      {/* Not Checked: "invisible" */}
      <svg
        className={clsx("h-5 w-5 text-secondary", checked ? "" : "opacity-0 group-hover:opacity-20")}
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
          clipRule="evenodd"
        />
      </svg>

      {/* Active: "border", Not Active: "border-2"
    Checked: "border-indigo-600", Not Checked: "border-transparent" */}
      <span
        className={clsx(
          "pointer-events-none absolute -inset-px rounded-lg border-[3px]",
          checked ? "border-secondary" : "border-white border-opacity-20 group-hover:border-opacity-50",
        )}
        aria-hidden="true"
      />
    </label>
  );
}

export default function NewActivationModal({
  setValue,
  onClose,
  open,
  availableActivations,
  onClickActivate,
  selectedActivation,
  handlePurchaseActivation,
}: Props) {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="relative space-y-6 rounded-2xl bg-primary text-white shadow-modal sm:w-full sm:p-2 xl:p-4">
        <div>
          <div className="flex justify-between text-white">
            <section className=" w-[95%] font-sora text-xl font-semibold xl:text-2xl">New Activation</section>
            <button type="button" onClick={onClose} className="my-auto cursor-pointer">
              <CloseIcon className="h-5 w-5 text-white" />
            </button>
          </div>
          <p className="font-satoshi text-lg font-medium opacity-50">Select an application to get started.</p>
        </div>

        {/* Radio buttons */}
        <div className="grid grid-cols-2 gap-2">
          {availableActivations.map((act) => (
            <div className="relative" key={`${act.key}new-act-modal`}>
              <ActivationCard
                onClick={(actKey) => setValue("activation", actKey)}
                activationKey={act.key}
                name={act.name}
                description={act.description}
                type={["poll", "social_share"].includes(act.key) ? "User Participation" : "User Benefit"}
                imgURL={act.image_url}
                checked={selectedActivation === act.key}
                disabled={!act.is_active}
              />
              {!act?.is_active && (
                <Button
                  text="UNLOCK"
                  variant="rustPinkSolid"
                  additionalClasses="!text-[0.66rem] !px-3 !rounded-md !py-1 absolute top-0 right-0 m-2.5"
                  onClick={() => handlePurchaseActivation(act.id)}
                />
              )}
            </div>
          ))}
        </div>

        <Button
          disabled={!selectedActivation}
          additionalClasses="ml-auto sm:py-3"
          text="ACTIVATE"
          variant="magnetiqSolid"
          onClick={onClickActivate}
        />
      </div>
    </Modal>
  );
}
